// theme.js
export const theme = {
    colors: {
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      gray: {
        50: "#f7fafc",
        // ...
        900: "#171923",
      },

      fontfamily: "font-family: Verdana, Geneva, Tahoma, sans-serif"
      // ...
    },
  };